import React, { useContext } from "react";

import { MySelectionContext } from "./MySelectionContext";
import { ButtonText } from "components/Atoms/Button";

const MySelectionButton = () => {
  const mySelection = useContext(MySelectionContext);

  if (!mySelection.enabled) {
    return null;
  }

  if (mySelection.selectionCount === 0) {
    return null;
  }

  return <div className="selectiontool-header-myselection-button">
    <ButtonText
      disabled={mySelection.selectionCount === 0}
      label={`${RESX.GeneralLabels.MySelection} (${mySelection.selectionCount})`}
      onClick={() => { mySelection.toggleShowOnlyMySelection(); }}
    />
  </div>;
};

export default MySelectionButton;